import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/client';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });

  const login = async (loginField, password) => {
    const res = await api.post('/auth/login', { login: loginField, password });
    const { token, user: u } = res.data;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(u));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(u);
    return u;
  };

  const updateUser = (patch) => {
    setUser(u => {
      const next = { ...u, ...patch };
      localStorage.setItem('user', JSON.stringify(next));
      return next;
    });
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    delete api.defaults.headers.common['Authorization'];
    setUser(null);
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }, []);

  // Ruolo/permessi cambiati in Impostazioni → Ruoli: il server li rilegge dal DB, qui si
  // riallinea il menu all'apertura e quando si torna sulla scheda, senza rifare il login.
  useEffect(() => {
    if (!user) return;
    const aggiorna = () => {
      if (!localStorage.getItem('token')) return;
      api.get('/auth/me').then(r => {
        const { ruolo, permessi, sedi_planning, is_allenatore } = r.data || {};
        if (ruolo) updateUser({ ruolo, permessi, sedi_planning, is_allenatore });
      }).catch(() => {});
    };
    aggiorna();
    window.addEventListener('focus', aggiorna);
    return () => window.removeEventListener('focus', aggiorna);
  }, [user?.id]);

  return <AuthContext.Provider value={{ user, login, logout, updateUser }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
